import React from "react";

import { useQuery } from "@apollo/client";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Hidden from "@material-ui/core/Hidden";
import PropTypes from "prop-types";

import RbFlexTable from "components/RbFlexTable";
import RbFlexTableBody from "components/RbFlexTableBody";
import RbFlexTableCell from "components/RbFlexTableCell";
import RbFlexTableHead from "components/RbFlexTableHead";
import RbFlexTableRow from "components/RbFlexTableRow";
import RbPagination from "components/RbPagination";

import { productListQuery } from "../productsGraphql";
import ProductRow from "./ProductRow";

const LIMIT = 20;

function ProductsContent(props) {
  const { searchParams, filters } = props;

  const [offset, setOffset] = React.useState(0);

  const {
    data: {
      productList: { edges = [], pageInfo: { total = 0 } = {} } = {},
    } = {},
  } = useQuery(productListQuery, {
    fetchPolicy: "server-only",
    variables: {
      filter: {
        ...searchParams.filter,
        ...filters,
      },
      sort: searchParams?.sort?.value,
      pagination: {
        offset,
        limit: LIMIT,
      },
    },
  });

  const handleChangePage = (_, page) => {
    setOffset((page - 1) * LIMIT);
  };

  const count = Math.ceil(total / LIMIT);
  const page = Math.floor(offset / LIMIT) + 1;

  return (
    <Container>
      <Box mb={5}>
        <RbFlexTable variant="card" expandable hoverable>
          <RbFlexTableHead>
            <RbFlexTableRow>
              <Hidden mdDown>
                <RbFlexTableCell flex="0 60px">ID</RbFlexTableCell>
              </Hidden>
              <RbFlexTableCell>Name</RbFlexTableCell>
              <RbFlexTableCell flex="0 80px" align="right">
                Price
              </RbFlexTableCell>
              <Hidden mdDown>
                <RbFlexTableCell flex="0 80px" align="right">
                  Inventory
                </RbFlexTableCell>
              </Hidden>
              <Hidden mdDown>
                <RbFlexTableCell>Categories</RbFlexTableCell>
              </Hidden>
            </RbFlexTableRow>
          </RbFlexTableHead>
          <RbFlexTableBody>
            {edges.map((edge) => (
              <ProductRow key={edge.id} product={edge} />
            ))}
          </RbFlexTableBody>
        </RbFlexTable>
      </Box>
      <RbPagination
        count={count}
        page={page}
        color="primary"
        siblingCount={0}
        onChange={handleChangePage}
      />
    </Container>
  );
}

ProductsContent.propTypes = {
  filters: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default React.memo(ProductsContent);
